module.exports = {
  SET_USER: "SET_USER",
  SIGN_OUT: "SIGN OUT",
  SHOW_MESSAGE: "[MESSAGE] SHOW MESSAGE",
  HIDE_MESSAGE: "[MESSAGE] HIDE MESSAGE",
  SET_CURRENCIES: '[DATA] SET_CURRENCIES',
  SET_DASHBOARD_DATA: '[DATA] SET DASHBOARD DATA',
  SET_DASHBOARD_DATA_DEFAULT: '[DATA] SET_DASHBOARD_DATA_DEFAULT',
  TYPE_CREDIT: 'CR',
  TYPE_DEBIT: 'DB',
  TYPE_MERCHANT_RECLAIM: 'MRC',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_BLOCKED: 'SET_BLOCKED',
  CHECK_KYC_SEEN: 'CHECK_KYC_SEEN',
  GET_COUNTRY: 'GET_COUNTRY',
  INCOGNITO: 'INCOGNITO',
  SET_MFA: 'SET_MFA',
  SET_FEEDBACK_SURVEY_STATE:'SET_FEEDBACK_SURVEY_STATE',
  SET_LAST_REFRENCE_ID: 'SET_LAST_REFRENCE_ID',
  GET_RECURRING_DATA: 'GET_RECURRING_DATA',
  SET_FIAT_SERVICE: 'SET_FIAT_SERVICE',
  GET_FIAT_SERVICE: 'GET_FIAT_SERVICE',
  GET_CONNECTED_BANKS: 'GET_CONNECTED_BANKS',
  CONNECT_BANK: 'CONNECT_BANK',
  GET_POCKYT_BANK_FORM_DATA: 'GET_POCKYT_BANK_FORM_DATA',
  CLEAR_BANK_FORMDATA: 'CLEAR_BANK_FORMDATA',
  GET_POCKYT_FEES: 'GET_POCKYT_FEES',
  CHECK_BANK_SEEN: 'CHECK_BANK_SEEN',
  REPLACE_BANK: 'REPLACE_BANK',

};
